<div class="mt-3">
  <h2 i18n>Résultat du calcul</h2>

  <ng-container *ngIf="error; else noError">
    <div class="d-flex justify-content-center">
      <div
        class="empty-state d-flex flex-column align-items-center py-8 col-md-8 col-sm-8 col-xs-12"
      >
        <div class="mb-4">
          <span class="icon icon-info" aria-hidden="true"></span>
        </div>
        <p class="mb-4">{{ getErrorMessage() }}</p>
      </div>
    </div>
  </ng-container>
  <ng-template #noError>
    <h3 i18n>Contribution au logement social ou abordable hors marché</h3>

    <div class="mb-4" i18n>
      Pour contribuer, vous pouvez vendre un immeuble à la Ville, réaliser un
      projet en mode clé en main ou design-construction, verser une contribution
      financière ou combiner l'une ou l'autre de ces options.<br /><br />
      Les coûts de construction associés aux projets en mode clés en main ou
      design-construction font l'objet d'une subvention distincte. Pour plus
      d'information, communiquez avec le Service de la stratégie immobilière et de l'habitation à :
      <a href="mailto: inclusion@montreal.ca">inclusion&#64;montreal.ca</a>.
    </div>

    <ng-container *ngIf="!isSocial(); else social">
      <div class="d-flex justify-content-center">
        <div
          class="empty-state d-flex flex-column align-items-center py-8 col-md-6 col-sm-8 col-xs-12"
        >
          <div class="mb-4">
            <span class="icon icon-info" aria-hidden="true"></span>
          </div>
          <p class="mb-4" i18n>
            La superficie résidentielle est inférieure ou égale à 18000 m². Le
            projet n'est pas assujetti au Règlement pour une métropole mixte.
          </p>
        </div>
      </div>
    </ng-container>
    <ng-template #social>
      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <div class="content-title" i18n>
              Vente d'un terrain sur le site du projet
            </div>
            <div class="d-flex justify-content-between">
              <div i18n>Superficie résidentielle</div>
              <div class="font-weight-bold">
                {{ searchResults.socialComponent.onSiteLivingArea }} m²
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div i18n>Prix d'achat par la Ville</div>
              <div class="font-weight-bold">
                {{
                  searchResults.socialComponent
                    .onSiteLivingAreaMonetaryEquivalent | currency: 'CAD'
                }}
              </div>
            </div>
          </div>
          <div>
            <div class="content-title" i18n>
              Vente d'un terrain hors du site du projet
            </div>
            <div class="d-flex justify-content-between">
              <div i18n>Superficie résidentielle</div>
              <div class="font-weight-bold">
                {{ searchResults.socialComponent.offSiteLivingArea }} m²
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div i18n>Prix d'achat par la Ville</div>
              <div class="font-weight-bold">
                {{
                  searchResults.socialComponent
                    .offSiteLivingAreaMonetaryEquivalent | currency: 'CAD'
                }}
              </div>
            </div>
          </div>
          <div>
            <div class="content-title" i18n>Contribution financière</div>
            <div class="d-flex justify-content-between">
              <div i18n>Montant à verser à la Ville</div>
              <div class="font-weight-bold">
                {{ searchResults.socialComponent.monetary | currency: 'CAD' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <hr />

    <h3 class="mt-4" i18n>Contribution au volet familial</h3>

    <div class="mb-4" i18n>
      Votre projet doit inclure des logements familiaux, à moins qu'il soit
      localisé dans un secteur 5B.
    </div>
    <ng-container *ngIf="!isFamily(); else family">
      <div class="empty-state d-flex flex-column align-items-center py-8">
        <div class="mb-4">
          <span class="icon icon-info" aria-hidden="true"></span>
        </div>
        <p class="mb-4" i18n>Aucune contribution requise pour ce volet.</p>
      </div>
    </ng-container>
    <ng-template #family>
      <h4 i18n>Logements à construire</h4>
      <div class="mb-4">
        <div class="d-flex justify-content-between">
          <div i18n>Nombre de logements familiaux</div>
          <div class="font-weight-bold">
            {{ searchResults.familyComponent.nbAffordableFamilyUnits }}
            <span i18n> logements</span>
          </div>
        </div>
      </div>
      <h4 i18n>Description d'un logement familial</h4>
      <div>
        <div class="d-flex justify-content-between">
          <div i18n>Nombre minimal de chambres à coucher</div>
          <div class="font-weight-bold">
            {{
              searchResults.familyComponent.affordableFamilyUnitDefinition
                .nbBedrooms
            }}
            <span i18n>chambres</span>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <div i18n>Superficie minimale</div>
          <div class="font-weight-bold">
            {{
              searchResults.familyComponent.affordableFamilyUnitDefinition
                .livingArea
            }}
            m²
          </div>
        </div>
      </div>
    </ng-template>

    <hr />
  </ng-template>
</div>
